import { NitroFetchOptions, NitroFetchRequest } from 'nitropack';
import { isNumber, isObject, isString } from '@borg/utils';

const baseApiFetch = $fetch.create({
  baseURL: process.server ? 'http://localhost:3000/api/proxy' : '/api/proxy',
});

export function apiFetch<T>(
  request: NitroFetchRequest,
  options?: NitroFetchOptions<NitroFetchRequest>,
) {
  const tokenCookie = useCookie('token').value;
  const tokenState = useToken().value;
  const token = tokenCookie ?? tokenState;
  const config = useRuntimeConfig();
  const { locale } = useNuxtApp().$i18n;

  const nextOptions: NitroFetchOptions<NitroFetchRequest> = {
    ...options,
    headers: {
      ...options?.headers,
      Cookie: `token=${token}`,
      'x-app': config.public.project.domain,
      'Accept-Language': locale.value,
    },
  };

  return baseApiFetch<T>(request, nextOptions);
}

export function parseApiFetchError(error: unknown) {
  if (isObject(error)) {
    const data = isObject(error.data) && isObject(error.data.data) ? error.data.data : {};
    const status = isNumber(error.status) ? error.status : undefined;
    const message =
      isObject(error.data) && isString(error.data.message) ? error.data.message : undefined;
    return { data, status, message };
  }
  return { data: {}, status: undefined, message: undefined };
}
